const hostDomain = window.location.origin;
const pathName = window.location.pathname;
// const isDev = hostDomain?.includes('dev-msb.meetn.com') || hostDomain?.includes('localhost');
const isDev = pathName?.startsWith("/rlinkdev_") || pathName?.startsWith("/meetndev_");
export const isRlink =
  pathName?.startsWith("/rlink_") || pathName?.startsWith("/rlinkdev_");
const DEFAULT_KEY = isRlink ? `-pl` : "";

export const meetnURL = isDev ? "dev-api.meetn.com" : "api.meetn.com";
export const rlinkURL = isDev ? "dev-api.r-link.com" : "live-api.r-link.com";

export const SOCKET_URL = isRlink ? `wss://${rlinkURL}` : `wss://${meetnURL}`;

export const MEDIA_ROOM = [""];
export const MEDIA_RESOURCE_URL = "";
export const TOKEN = "7c36439a87bc9f39c0a2";
// export const DOMAIN = isDev ? "dev-wss.meetn.com" :'prod-wss.meetn.com' ;
export const DOMAIN = "prod-wss.meetn.com";
// export const DOMAIN = 'dev-wss.meetn.com';
export const FOCUS = `focus.${DOMAIN}`;
export const MUC = `conference.${DOMAIN}`;
export const SERVICEURL = `wss://${DOMAIN}/xmpp-websocket`;
export const WEBSOCKETKEEPALIVEURL = isRlink
  ? "https://meet.r-link.com"
  : "https://meetn.com";
export const SOCKET_CON = isRlink ? "msb-pl" : "con-msb";
export const MEDIA_SET = `media-set${DEFAULT_KEY}`;
export const WIDGET_HIDE = `widget-hide${DEFAULT_KEY}`;
export const MEDIA_PLAYER = `media-player${DEFAULT_KEY}`;
export const MEDIA_PLAYER_SEEK_UPD = `media-player-seek-upd${DEFAULT_KEY}`;
